module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-liste-demande h-100"
  }, [_c('div', {
    staticClass: "espace-salarie h-100",
    class: !_vm.isModeManager ? 'd-block' : 'd-none'
  }, [_c('espace-salarie', {
    on: {
      "afficherModalSupprimerAbsence": _vm.afficherModalSupprimerAbsence,
      "afficherModalAjouterAbsence": _vm.afficherModalAjouterAbsence,
      "afficherModalDetailAbsence": _vm.afficherModalDetailAbsence,
      "afficherModalChangerEtatAbsence": _vm.afficherModalChangerEtatAbsence
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "espace-manager h-100",
    class: _vm.isModeManager ? 'd-block' : 'd-none'
  }, [_c('espace-manager', {
    on: {
      "afficherModalValiderAbsence": _vm.afficherModalValiderAbsence,
      "afficherModalDetailAbsence": _vm.afficherModalDetailAbsence,
      "afficherModalChangerEtatAbsence": _vm.afficherModalChangerEtatAbsence
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e8e47c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsences/listeDesDemandes/listeDesDemandes.vue.html
// module id = luIS
// module chunks = 2